
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/online-counselling/[slug]",
      function () {
        return require("private-next-pages/online-counselling/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/online-counselling/[slug]"])
      });
    }
  